// extracted by mini-css-extract-plugin
module.exports = {"root":"AlertBanner_root__3hIj1","content":"AlertBanner_content__1AWJ9","action_icon":"AlertBanner_action_icon__1K4SO","text":"AlertBanner_text__3BQvj"};